/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Migrate2Inputs */

const en_wc_vs_migrate2 = /** @type {(inputs: Wc_Vs_Migrate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep using .docx. It is WordCraft's native format, so you can move back and forth.`)
};

/**
* | output |
* | --- |
* | "Keep using .docx. It is WordCraft's native format, so you can move back and forth." |
*
* @param {Wc_Vs_Migrate2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_migrate2 = /** @type {((inputs?: Wc_Vs_Migrate2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Migrate2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_migrate2(inputs)
});
export { wc_vs_migrate2 as "wc.vs.migrate2" }